<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Assets'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-row class="extra-bottom-padding">
      <tidy-text
        [body]="'Smart maintenace helps you track and maintain your property\'s assets. Add your appliances and other important items to get started:'" />
    </tidy-row>

    @if (loaded) {
      <form [formGroup]="form" action="#">
        <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 15px">
          <tidy-select
            [icon]="'assets/svg/list.svg'"
            [label]="'Add new item'"
            [items]="maintenanceItems"
            [multiple]="false"
            [form]="form.get('newItem')"
            [formControlName]="newItem"
            [submitted]="submitted"
            [errorMessage]="'Please select an item.'" />
          <div style="width: 120px" class="select-height-button">
            <tidy-button
              [text]="'+ Add Item'"
              [smallBody]="true"
              [action]="boundAddItem"
              class="secondary full-width" />
          </div>
        </div>
      </form>
      @for (item of addedItems; track item; let i = $index; let last = $last) {
        <div>
          <tidy-row [alignLastItemRight]="true" [ngClass]="{'extra-bottom-padding': last}">
            <tidy-image
              [src]="item.icon"
              class="header-size" />
            <tidy-text
              [body]="item.viewValue" />
            <div>
              <tidy-image
                (action)="removeItem(item)"
                [src]="'assets/svg/close-outline.svg'"
                class="body-size" />
            </div>
          </tidy-row>
        </div>
      }
      <tidy-button
        [text]="'Save Items'"
        [action]="boundSaveItems"
        class="primary" />
    }

    @if (!loaded) {
      <ion-skeleton-text animated="true" style="width: 100%; height: 605px" />
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
